module.exports = __webpack_public_path__ + "f5e63584dd4e5450124b1e772e594e30.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/MS.svg
// module id = 49CT
// module chunks = 0